import { render } from "./Recipes.vue?vue&type=template&id=574c43bd&scoped=true"
import script from "./Recipes.vue?vue&type=script&lang=js"
export * from "./Recipes.vue?vue&type=script&lang=js"

import "./Recipes.vue?vue&type=style&index=0&id=574c43bd&scoped=true&lang=css"

import exportComponent from "/home/roland/coding/Kitchen101/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-574c43bd"]])

export default __exports__